module.exports = __webpack_public_path__ + "media/images/views/dashboard/bronze-dcb70f9f257766cc5998dd6fb755a821.png";